module.exports = __webpack_public_path__ + "img/frame.478bcacd.svg";